if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler = async (evt) => {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const cart = await fetch("/cart.js").then(results => results.json());

      const addToCart = () => {
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return;
              }

              this.cartNotification.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(async () => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');

              // Updates minicart when product is added
              const miniCart = await fetch("/cart?view=mini").then(results => results.text());
              const parser = new DOMParser();
              const parsedData = parser.parseFromString(miniCart, 'text/html').querySelector('#mini-cart-flyout');
              const miniCartUpdate = document.querySelector('#mini-cart-flyout');

              if (miniCartUpdate) {
                miniCartUpdate.innerHTML = parsedData.innerHTML;

                const disableScroll = document.querySelector('html');
                const miniCartCover =  document.getElementById('miniCartCover');
                const miniCartFlyoutClose = miniCartUpdate.querySelector('.mini-cart-flyout__close');
                if (miniCartFlyoutClose) {
                  miniCartFlyoutClose.addEventListener('click', function () {
                    if(miniCartUpdate.classList.contains('mini-cart-flyout-on-screen')) {
                      miniCartUpdate.classList.remove('mini-cart-flyout-on-screen');
                      if(miniCartCover && miniCartCover.classList.contains('miniCartCoverFaded')) {
                        miniCartCover.classList.remove('miniCartCoverFaded');
                      }
                      if (disableScroll && disableScroll.classList.contains('disableScroll')) {
                        disableScroll.classList.remove('disableScroll');
                      }
                    }
                  });
                }

                const miniCartItem = miniCartUpdate.querySelector('cart-items');
                if (miniCartItem && miniCartItem.classList.contains('hidden')) {
                  miniCartItem.classList.remove('hidden');
                }

                miniCartItem.getSectionsToRender().map((section) => section.id);

                THKAnalitycs['removeFromCart'].refresh();
                THKAnalitycs['addToCart'].refresh();

                const miniCartOpen = document.querySelector('.mini-cart-button');
                miniCartOpen.click();
              }

              const quickViewModalCloseBtn = document.getElementById('ModalClose-QuickView');
              if (!quickViewModalCloseBtn) return;

              quickViewModalCloseBtn.click();
            });
      };

      if(cart && cart.items && cart.items.length){
        const pdpItem = formData.get("id");
        const quantity = formData.get("quantity");
        const product = cart.items.find(item => item.variant_id === Number(pdpItem));

        if(product){
          if(Number(quantity) + product.quantity > 10){
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            this.handleErrorMessage(`Cannot have more than 10 ${product.title} in your cart`);
          } else {
            addToCart();
          }
        } else {
          addToCart();
        }
      } else {
        addToCart();
      }
    };

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
